import React from 'react';
import {
  initMercadoPago,
  CardNumber,
  SecurityCode,
  ExpirationDate,
  createCardToken,
} from '@mercadopago/sdk-react';
import config from '../../config';

import Button from '../commons/Button';

initMercadoPago(config.MP_PUBLIC_KEY, {
  locale: 'es-AR'
});

export default function MPCardData({ paymentNext, ...rest }) {
  const cardToken = async () => {
    const response = await createCardToken({
      cardholderName: document.getElementById("nombre").value,
      identificationType: document.getElementById("tipo_documento").value, 
      identificationNumber: document.getElementById("documento").value,
    });
    console.log('Card Token Response = ', response);
    //paymentNext(response)
  };
  return (
    <>
      <h1 className="text-2xl font-bold text-center">Datos de la tarjeta</h1>


      <input id="nombre" placeholder="Nombre como aparece en la tarjeta" style={{height: "40px", margin: "4px", color: "black", fontSize: "24px",}} />
      <input id="documento" placeholder="Documento" style={{height: "40px", margin: "4px", color: "black", fontSize: "24px",}} />
      <select id="tipo_documento" style={{height: "40px", margin: "4px", color: "black", fontSize: "24px"}}>
        <option value="DNI" selected>DNI</option>
      </select>
      {/*<input placeholder="Email" style={{height: "40px", margin: "4px", color: "black", fontSize: "24px",}} />*/}

      <CardNumber placeholder="Card Number" style={{height: "40px", margin: "4px", color: "black", fontSize: "24px",}} />
      <div className="grid grid-cols-2 gap-4 h-48">
        <SecurityCode placeholder="Security Code" style={{height: "40px", margin: "4px", color: "black", fontSize: "24px",}}/>
        <ExpirationDate placeholder="Expiration Date" mode="short" style={{ height: "40px", margin: "4px", color: "black", fontSize: "24px",}}/>
      </div>
        <Button
          className="btn-primary btn-block"
          title={"Pagar"}
          onClick={() => cardToken()}
          disabled={false}
        />
    </>
  );
};
